import { useState } from "react";
import Answer, { Color } from "../../model/answer";
import { setAnswerState } from "../providers/answer";


export function useAnswer(content: string, player1?: boolean, player2?: boolean, color?: Color, correct?: boolean): [Answer, Function] {
    const [state, setState] = useState({
        content: content,
        color: color || Color.Black,
        player1: player1 || false,
        player2: player2 || false,
        correct: correct,
    });

    return [state, (color: Color, player: string, playerVal: boolean) => setAnswerState(setState, color, player, playerVal)];
}
